/*
 * In-house Personalizer PDP purchase-block presenter.
 *
 * The purchase block keeps the theme's native quantity stepper (the dropdown facade this
 * file used to install was reverted by product decision — the stepper IS the chosen
 * control, so Shopify stays the only owner of quantity changes with no shadow control).
 * This presenter only pins the PZ floor to one and mirrors that boundary into the native
 * minus button's disabled state; input/change remain the native stepper's event contract.
 *
 * What remains is grid adoption, matching the LIVE CustomAll rows: the Shipping
 * Protection group (.shp-upsell-group, injected elsewhere in the form by its app script)
 * becomes row 1, and the runtime's .pz-preview-trigger becomes the full-width row 2.
 * Nodes are MOVED, never cloned, so every owner's handlers and state sync stay bound
 * (both still live inside the same product form, so the SHP checkbox keeps submitting);
 * when an owner re-renders and mints a fresh node, the stale adopted one is dropped for
 * it. The adopted Preview button carries a plain "Preview" label (title case, no
 * uppercase transform) to match the CustomAll live PDP.
 */
(function () {
  if (!document.documentElement.classList.contains('pz-inhouse-page')) return;

  var PREVIEW_LABEL = 'Preview';

  function syncQuantityFloor(input) {
    var value = Number(input.value);
    if (!Number.isFinite(value) || value < 1) {
      input.value = '1';
      value = 1;
    }
    var minus = input.pzQuantityFloorMinus;
    if (!minus) return;
    var atFloor = value <= 1;
    minus.disabled = atFloor;
    if (atFloor) minus.setAttribute('aria-disabled', 'true');
    else minus.removeAttribute('aria-disabled');
  }

  function ensureQuantityFloor() {
    var grid = document.querySelector('.main-product-section .product-form__quantity-and-btn');
    if (!grid) return false;
    var input = grid.querySelector(':scope > .product-form__quantity input[name="quantity"]');
    var minus = grid.querySelector(':scope > .product-form__quantity button[name="minus"]');
    if (!input || !minus) return false;

    input.setAttribute('min', '1');
    input.setAttribute('data-min', '1');
    input.pzQuantityFloorMinus = minus;
    if (!input.pzQuantityFloorBound) {
      var sync = function () { syncQuantityFloor(input); };
      input.addEventListener('input', sync);
      input.addEventListener('change', sync);
      input.pzQuantityFloorBound = true;
    }
    syncQuantityFloor(input);
    return true;
  }

  function adoptIntoGrid(selector, onAdopt) {
    // The cart Edit Design embed restyles this page as a modal with its own button stack;
    // the purchase-grid adoption is a PDP-only presentation contract.
    if (document.documentElement.classList.contains('pz-cart-edit-embed')
        || document.body.classList.contains('pz-cart-edit-embed')) return false;
    var grid = document.querySelector('.main-product-section .product-form__quantity-and-btn');
    if (!grid) return false;
    var nodes = document.querySelectorAll(selector);
    var outside = null;
    for (var i = 0; i < nodes.length; i += 1) {
      if (!grid.contains(nodes[i])) outside = nodes[i];
    }
    if (!outside) return nodes.length > 0;
    // Owners (personalizer runtime, SHP app) rebuild their node in its original slot,
    // so a node found outside the grid is always the authoritative one: adopt it and
    // drop any previously adopted node the owner no longer controls.
    var adopted = grid.querySelector(':scope > ' + selector);
    if (adopted && adopted !== outside) adopted.remove();
    if (onAdopt) onAdopt(outside);
    grid.appendChild(outside);
    return true;
  }

  function ensurePreviewTriggerInGrid() {
    var previewAdopted = adoptIntoGrid('.pz-preview-trigger', function (node) {
      if (node.textContent !== PREVIEW_LABEL) node.textContent = PREVIEW_LABEL;
    });
    adoptIntoGrid('.shp-upsell-group');
    ensureQuantityFloor();
    return previewAdopted;
  }

  function ensureTriggerObserver() {
    var owner = document.querySelector('.main-product-section');
    if (!owner || owner.pzPreviewTriggerObserver) return Boolean(owner);
    var scheduled = null;
    var observer = new MutationObserver(function () {
      clearTimeout(scheduled);
      scheduled = setTimeout(ensurePreviewTriggerInGrid, 0);
    });
    observer.observe(owner, { childList: true, subtree: true });
    owner.pzPreviewTriggerObserver = observer;
    return true;
  }

  function init() {
    ensurePreviewTriggerInGrid();
    if (ensureTriggerObserver()) return;
    var poll = setInterval(function () {
      ensurePreviewTriggerInGrid();
      if (ensureTriggerObserver()) clearInterval(poll);
    }, 300);
    setTimeout(function () { clearInterval(poll); }, 30000);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);

  ['variant:change', 'on:variant:change'].forEach(function (eventName) {
    document.addEventListener(eventName, function () {
      setTimeout(ensurePreviewTriggerInGrid, 0);
    });
  });

  document.addEventListener('shopify:section:load', init);
}());
